import React from "react";

const VideoBarPersonCamOn = () => {
  return (
    <svg
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="7" width="14" height="10" rx="1.21875" fill="#FA544D" />
      <path
        d="M16.2188 12.7036C15.6771 12.3909 15.6771 11.6091 16.2187 11.2964L22.7813 7.50749C23.3229 7.19476 24 7.58568 24 8.21114L24 15.7889C24 16.4143 23.3229 16.8052 22.7813 16.4925L16.2188 12.7036Z"
        fill="#FA544D"
      />
    </svg>
  );
};

export default VideoBarPersonCamOn;
